import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=a21ee330&scoped=true"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21ee330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21ee330')) {
      api.createRecord('a21ee330', component.options)
    } else {
      api.reload('a21ee330', component.options)
    }
    module.hot.accept("./SendMessage.vue?vue&type=template&id=a21ee330&scoped=true", function () {
      api.rerender('a21ee330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/SendMessage.vue"
export default component.exports